import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MailFormData } from '../models/mail-form.model';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  sendMail(formValue: any) {
    const message = new MailFormData(formValue).getMailMessage();
    const formData = new FormData();
    for (const prop in message) {
      formData.append(prop, message[prop]);
    }

    return this.http.post('/contact-form.php', formData);
  }
}
